import { Badge } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import type { TExaminationStatus } from '../model'

interface Props {
  status: TExaminationStatus
  children: ReactNode
}

const examinationStatusStyles: Record<
  TExaminationStatus,
  { bg: string; color: string }
> = {
  COMPLETED: { bg: 'badge.green.20', color: 'badge.green.100' },
  DEFERRED: { bg: 'badge.red.20', color: 'badge.red.100' },
}

export function ExaminationStatusBadge({ status, children }: Props) {
  const { bg, color } = examinationStatusStyles[status]

  return (
    <Badge
      px={2}
      py={0.5}
      borderRadius="md"
      fontSize="xs"
      w="fit-content"
      bg={bg}
      color={color}
    >
      {children}
    </Badge>
  )
}
